import axios from '@/utils/axios';
import type { Wallet } from '@/features/users/shared/types';

export type WalletUpdateDto = Partial<
  Pick<Wallet, 'name' | 'exp_month' | 'exp_year' | 'default'>
>;

export type StripeWalletPreviewItem = {
  stripe_id: string;
  brand: string;
  last4: string;
  exp_month: string | number;
  exp_year: string | number;
  type: string;
  action?: 'create' | 'update';
  wallet_id?: number;
  country?: string;
  name?: string;
  default?: boolean;
};

const extractResponseData = <T>(payload: unknown, fallback: T): T => {
  if (Array.isArray(payload)) return payload as T;

  if (payload && typeof payload === 'object') {
    const response = payload as { data?: unknown };
    if (Array.isArray(response.data)) return response.data as T;

    if (response.data && typeof response.data === 'object') {
      const nestedResponse = response.data as { data?: unknown };
      if (Array.isArray(nestedResponse.data)) return nestedResponse.data as T;
    }
  }

  return fallback;
};

export const updateWallet = async (
  walletId: number,
  walletData: WalletUpdateDto
) => axios.put(`/wallets/${walletId}`, walletData);

export const deleteWallet = async (walletId: number) =>
  axios.delete(`/users/wallets/${walletId}`);

export const getStripeWalletPreview = async (
  userId: number
): Promise<StripeWalletPreviewItem[]> => {
  const response = await axios.get(`/users/${userId}/wallets/stripe/preview`);
  return extractResponseData<StripeWalletPreviewItem[]>(response.data, []);
};

export const syncStripeWallets = async (userId: number) =>
  axios.post(`/users/${userId}/wallets/stripe/sync`);
